<template>
<div v-if="item != null">
    <v-row align="center" justify="center">
        <v-col cols="1"></v-col>
        <v-col>
        <v-card elevation="2" style="width:800px; min-height:670px">
            <v-card-title>Key Information</v-card-title>
            <v-divider class="mx-4 ma-1"></v-divider>
            <v-row class="ma-1" justify="center" align="center">
                <v-col cols="4">
                    <v-text-field v-model="item.oem" readonly dense type="text" label="OEM:" outlined></v-text-field>
                    <v-text-field v-model="item.ic" readonly dense type="text" label="IC:" outlined></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field v-model="item.fcc" readonly dense type="text" label="FCC:" outlined></v-text-field>
                    <v-text-field v-model="item.iSKU" readonly dense type="text" label="Internal Sk:" outlined></v-text-field>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="3">
                    <img @click="showModal" style="cursor:pointer" :src="item.image" height="120" width="120">
                </v-col>
            </v-row>
            <v-row class="ma-1" style="height:50px">
                <v-col cols="4">
                    <v-text-field v-model="item.globalpart" readonly dense type="text" label="Global Part:" outlined></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field v-model="item.freq" readonly dense type="text" label="Frequency:" outlined></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field v-model="item.threshold" readonly dense type="text" label="Threshold:" outlined></v-text-field>
                </v-col>
            </v-row>
            <v-row class="ma-1">
                <v-col cols="4">
                    <v-text-field v-model="item.keyType.type" readonly dense type="text" label="Key Type:" outlined></v-text-field>
                    <v-text-field v-model="item.description" readonly dense type="text" label="Description:" outlined></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field v-if="item.transponder" v-model="item.transponder.transponder" readonly dense type="text" label="Transponder:" outlined></v-text-field>
                    <v-text-field v-else readonly dense type="text" label="Transponder:" outlined></v-text-field>
                    <v-text-field v-model="item.notes" readonly dense type="text" label="Notes:" outlined></v-text-field>

                </v-col>
                <v-col cols="4">
                    <v-card-subtitle class="pa-1">Buttons:</v-card-subtitle>
                    <v-chip color="primary" text-color="white" style="margin-left:2px; margin-top:2px" v-for="button in item.buttons">
                        {{button.button}}
                    </v-chip>
                </v-col>
            </v-row>
            <v-divider class="mx-4 ma-0" style="margin-top:-2% !important"></v-divider>
            <v-row >
              <v-col>
                <v-card-title style="height:50px;margin-top:-3% !important">Manufacturers:</v-card-title>
                <div v-if="item.manAssociation.length > 0" style="margin-left:15%">
                    <v-chip color="primary" text-color="white" style="margin-left:2px; margin-top:2px" v-for="sup in item.manAssociation">
                        {{sup.manufacturer.name}} - {{sup.man_sku}}
                    </v-chip>
                </div>
                <v-divider class="mx-4 ma-2"></v-divider>
              </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card-title style="height:50px;margin-top:-4% !important">Suppliers:</v-card-title>
                    <div v-if="item.supAssociation.length > 0" style="margin-left:15%">
                        <v-chip color="primary" text-color="white" style="margin-left:2px; margin-top:2px" v-for="sup in item.supAssociation">
                            {{sup.supplier.name}} - {{sup.sup_sku}}
                        </v-chip>
                    </div>
                    <v-divider class="mx-4 ma-2"></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card-title style="height:50px;margin-top:-4% !important">Compatible Vehicles:</v-card-title>
                    <div v-if="item.supAssociation.length > 0" style="margin-left:15%">
                        <v-chip color="primary" outlined style="margin-left:2px; margin-top:2px" v-for="veh in item.compatibleVeh">
                            {{veh.key.make}} - {{veh.key.model}} - {{veh.key.year}}
                        </v-chip>
                    </div>

                </v-col>
            </v-row>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text-color="white" text @click="close">
                    Close
                </v-btn>
            </v-card-actions>

        </v-card>
        </v-col>
    </v-row>

    <modal v-if="item != null" name="image" :width="500" :height="500">
        <img :src="item.image" height="500" width="500">
    </modal>
</div>
</template>
<script>

export default {
    props: {
        item: Object
    },
    methods: {
            close() {
                this.$parent.onClose();
            },
            showModal() {
                this.$modal.show('image');
            },
    }
}

</script>
